import { PlayIcon } from '@heroicons/react/24/solid'

interface IArticle {
    url: string
    title: string
    description: string
    srcImg: string
    altImg: string
    subtitle: string
    knowMoreText: string
    key: number
    linkId?: string
}

export const ArticleC: React.FC<IArticle> = (props) => {
    const { url, srcImg, subtitle, title, description, knowMoreText, linkId } =
        props

    const linkTitle = `En savoir plus sur ${title}`

    return (
        <article className="flex flex-col gap-4 rounded-6xl">
            <a
                id={linkId}
                href={url}
                title={linkTitle}
                className="flex flex-col gap-4 items-start"
            >
                <div
                    className="rounded-[2.5rem] border w-full order-1"
                    style={{
                        height: '14rem',
                        backgroundImage: `url(${srcImg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                />

                <p className="font-bold text-2xl order-3">{title}</p>

                <p className="text-sm text-neutral-500 order-4">
                    {description}
                </p>

                <p className="text-lg order-2">{subtitle}</p>

                <span className="mt-auto text-primary-400 button button-link button-icon order-5">
                    <PlayIcon aria-hidden={true} className="w-4" />
                    {knowMoreText}
                </span>
            </a>
        </article>
    )
}
